export default "__VITE_ASSET__DVMc80ie__"